import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ApplicationGate } from './components/ApplicationGate';
import { ApplicationProvider } from './state/ApplicationProvider';
import { CommercialProvider } from './state/CommercialProvider';
import { FinanceProvider } from './state/FinanceProvider';
import { ProcurementProvider } from './state/ProcurementProvider';
import { ProductionProvider } from './state/ProductionProvider';
import { WorkforceProvider } from './state/WorkforceProvider';
import './styles.css';
import './live.css';
import './governance-live.css';
import './commercial.css';
import './procurement.css';
import './finance.css';
import './production.css';
import './workforce.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element was not found');
}

createRoot(root).render(
  <StrictMode>
    <ApplicationProvider>
      <ApplicationGate>
        <CommercialProvider>
          <ProcurementProvider>
            <FinanceProvider>
              <ProductionProvider>
                <WorkforceProvider>
                  <App />
                </WorkforceProvider>
              </ProductionProvider>
            </FinanceProvider>
          </ProcurementProvider>
        </CommercialProvider>
      </ApplicationGate>
    </ApplicationProvider>
  </StrictMode>
);
